module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-1.58c5a801.mp3";